import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingImageToTextConfig } from '@/data/landingConfig/landingImageToTextConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageToText } from './schemaObject';

interface Props {}
const ImageToText: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ImageToText} />
			<LandingTemplate
				data={landingImageToTextConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageToText()}
			/>
		</>
	);
};

export default ImageToText;
